import { useEffect } from 'react';
import { useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';
import { setupRUM } from '../coralogix-rum';

const useRUM = () => {
    const client = useGetUserInfoSelector();

    useEffect(() => {
        if (!client) return;

        setupRUM({
            id: client.id,
            email: client.email,
            first_name: client.first_name,
            last_name: client.last_name,
        });
    }, [client?.id, client?.email, client?.first_name, client?.last_name]);
};

export default useRUM;
